import { getFormValues } from 'redux-form';
import { getProject } from '../../../HttpRequests/projects';
import { loadProject } from '../State/project';
import { FORM_NAME } from '../Form';
import alertIfClientIsHighRisk from './alertIfClientIsHighRisk';
import handleException from '../../../Core/Helpers/handleException';

export default () => async (dispatch, getState) => {

  const values = getFormValues(FORM_NAME)(getState());

  if (!values) return;
  
  try {

    const { project_id: id } = values;

    const params = {};
    
    params.include = [
      'clientSite',
      'clientSite.client',
      'clientSite.client.clientContacts'
    ].join();

    params['filter[status_key]'] = [1,2];

    const response = await getProject({ id, params });

    dispatch(loadProject(response.data.data));

    dispatch(alertIfClientIsHighRisk(response.data.data));

  } catch (error) {

    handleException(error);

  }
}